import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { setLookingFor } from '../../store/slices/authSlice';
import { useTranslation } from 'react-i18next';
import { getLookingForOptions } from '../../utils/lookingForOptions';

const LookingFor = ({ nextPath = '/auth/recent-pics', backPath = '/auth/interested' }) => {
    const { t } = useTranslation();
    const savedType = useSelector(state => state.auth.LookingFor);
    const [selectedType, setSelectedType] = useState(savedType || '');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const lookingForOptions = getLookingForOptions(t);

    const handleNext = () => {
        if (selectedType) {
            // Dispatch to Redux with the new field name
            dispatch(setLookingFor(selectedType));
            navigate(nextPath);
        }
    };

    const handleOptionSelect = async (value) => {
        setSelectedType(value);
    };

    return (
        <div className="page-wrapper">
            <div className="page-content">
                <div className="container">
                    <div className="account-area style-2">
                        {/* Retour vers l'étape précédente de la logique du parcours (pas l'historique du navigateur : */}
                        {/* la redirection automatique de ProtectedAuthRoute peut remplacer l'historique réel) */}
                        <a href="#" onClick={(e) => { e.preventDefault(); navigate(backPath); }} className="back-btn">
                            <ChevronLeft className="icon" />
                        </a>
                        <div className="dz-title">
                            <h2>{t('lookingFor.title')}</h2>
                        </div>
                        <div className="radio style-4 row g-2">
                            {lookingForOptions.map((option) => (
                                <div key={option.value} className="col-4">
                                    <label className="radio-label">
                                        <input
                                            type="radio"
                                            name="lookingFor"
                                            checked={selectedType === option.value}
                                            onChange={() => handleOptionSelect(option.value)}
                                        />
                                        <span className="checkmark">
                                            <img src={option.icon} alt="" />                         
                                            <span className="text">{option.label}</span>  
                                        </span>
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {/* Footer */}
            <div className="footer fixed bg-white p-b15">
                <div className="container">
                    <button 
                        onClick={handleNext}
                        className="btn btn-lg btn-gradient w-100 dz-flex-box btn-shadow rounded-xl"
                        disabled={!selectedType}
                    >
                         {t('interested.next')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LookingFor;
